<template>
  <div class="ud-tool">
    <div class="ud-controls">
      <el-radio-group v-model="ver" size="small">
        <el-radio-button label="4">UUID v4</el-radio-button>
        <el-radio-button label="7">UUID v7</el-radio-button>
      </el-radio-group>
      <span class="ud-lbl">{{ $t('tool.UuidGenerator.count') }}</span>
      <el-input-number v-model="count" :min="1" :max="50" size="small" style="width:100px" />
      <el-checkbox v-model="upper" size="small">{{ $t('tool.UuidGenerator.upper') }}</el-checkbox>
      <span class="ud-spacer" />
      <el-button type="primary" size="small" icon="el-icon-refresh" @click="generate">{{ $t("common.action.generate") }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="copyAll" :disabled="!list.length">{{ $t('tool.UuidGenerator.copyAll') }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="list=[]" :disabled="!list.length">{{ $t("common.action.clear") }}</el-button>
    </div>
    <div class="ud-list" v-if="list.length">
      <div v-for="(id,i) in list" :key="i" class="ud-item" @click="copy(id)">
        <span class="ud-num">{{ i + 1 }}</span>
        <code>{{ id }}</code>
        <span class="ud-copy"><i class="el-icon-document-copy" /> {{ $t('tool.UuidGenerator.copy') }}</span>
      </div>
    </div>
    <div class="ud-empty" v-else>{{ $t('tool.UuidGenerator.emptyHint') }}</div>
  </div>
</template>

<script>
export default {
  name:'UuidGeneratorTool', props:{ config:{ type:Object, default:()=>({}) } },
  data:()=>({ ver:'4', count:5, upper:false, list:[] }),
  methods:{
    v4(){ return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,c=>{const r=Math.random()*16|0;return(c==='x'?r:(r&0x3|0x8)).toString(16)}) },
    v7(){ const ts=Date.now().toString(16).padStart(12,'0');const r=Array.from(crypto.getRandomValues(new Uint8Array(10)),b=>b.toString(16).padStart(2,'0')).join('');return`${ts.slice(0,8)}-${ts.slice(8,12)}-7${r.slice(0,3)}-${(8+Math.random()*4|0).toString(16)}${r.slice(3,6)}-${r.slice(6,12)}` },
    generate(){ this.list=Array.from({length:this.count},()=>{const u=this.ver==='7'?this.v7():this.v4();return this.upper?u.toUpperCase():u}) },
    copy(t){ navigator.clipboard.writeText(t);this.$message.success(this.$t("common.status.copied")) },
    copyAll(){ if(!this.list.length)return;navigator.clipboard.writeText(this.list.join('\n'));this.$message.success(this.$t('tool.UuidGenerator.copiedAll')) },
    doAction(a){ if(a==='clear')this.list=[] }
  },
  mounted(){ this.generate() }
}
</script>

<style scoped>
.ud-tool { display: flex; flex-direction: column; gap: 14px; }

.ud-controls { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.ud-lbl { font-size: 12px; color: #909399; font-weight: 600; }
.ud-spacer { flex: 1; }

.ud-list { display: flex; flex-direction: column; gap: 6px; }
.ud-item {
  display: flex; align-items: center; gap: 12px;
  padding: 10px 16px; background: #fafbfc; border: 1px solid #ebeef5;
  border-radius: 8px; cursor: pointer; transition: all .15s;
}
.ud-item:hover { border-color: #4e7cff; background: #f0f4ff; }
.ud-num { font-size: 11px; color: #c0c4cc; min-width: 20px; text-align: right; }
.ud-item code { flex: 1; font-family: 'JetBrains Mono','Consolas',monospace; font-size: 14px; color: #303133; word-break: break-all; user-select: all; }
.ud-copy { font-size: 12px; color: #c0c4cc; flex-shrink: 0; opacity: 0; transition: opacity .12s; }
.ud-item:hover .ud-copy { opacity: 1; color: #4e7cff; }

.ud-empty { text-align: center; padding: 40px; color: #c0c4cc; font-size: 14px; }
</style>
